import React, { HTMLAttributes } from "react";
import BaseButton from "../../atoms/baseButton";
import EventFormModal from "../eventFormModal";

interface IEventFooter {}

type TEventFooterProps = IEventFooter & HTMLAttributes<HTMLDivElement>;

const EventFooter: React.FC<TEventFooterProps> = (props) => {
  const { ...otherProps } = props;
  const [showModal, setShowModal] = React.useState<boolean>(false);

  const showEvent = false;

  if (showEvent) {
    return (
      <div
        className="absolute flex justify-center w-full bottom-0 h-[172px] bg-eventFooterBg_m largeMobile:bg-eventFooterBg_p laptop:bg-eventFooterBg_d bg-bottom largeMobile:bg-top bg-cover bg-no-repeat text-black"
        {...otherProps}
      >
        <div className="flex flex-col laptop:flex-row items-center gap-3 justify-center mt-[2%] laptop:mt-[1%]">
          <div className="flex flex-col items-center gap-1">
            <span className="text-sm laptop:text-2xl font-extrabold">
              2025年4月1日前登記{" "}
            </span>
            <span className="text-[10px] laptop:text-sm">
              Register before April 1, 2025.{" "}
            </span>
            <span className="text-sm laptop:text-2xl font-extrabold">
              搶先抽中免費任充一個月 (名額4個){" "}
            </span>
            <span className="text-[10px] laptop:text-sm">
              Be among the first to win one month of free charging (4 spots
              available)!
            </span>
          </div>
          <BaseButton
            colorBase="yellow"
            className="w-[130px] laptop:w-[160px] relative"
            onClick={() => setShowModal(true)}
          >
            <div className="flex flex-col">
              <span className="text-sm laptop:text-xl text-black">
                立即登記
              </span>
              <span className="text-xs laptop:text-sm text-black">
                Register Now
              </span>
            </div>
            <img
              className="absolute -top-[15px] -right-[5px] animate-waving-hand w-10 h-10"
              src={require("../../../assets/icons/gift_right.png")}
              alt="gift"
            />
          </BaseButton>
        </div>
        <EventFormModal open={showModal} onClose={() => setShowModal(false)} />
      </div>
    );
  } else {
    return (
      <div
        className="absolute flex justify-center w-full bottom-0 h-[175px] bg-eventFooterBg_m largeMobile:bg-eventFooterBg_p laptop:bg-eventFooterBg_d bg-bottom largeMobile:bg-top bg-cover bg-no-repeat text-black"
        {...otherProps}
      >
        <div className="flex flex-row gap-3 items-center justify-center">
          <div className="flex flex-col gap-2 font-bold text-center laptop:text-right mt-12 laptop:mt-0">
            <div className="text-2xl laptop:text-5xl">立即下載</div>
            <div className="text-base laptop:text-4xl">Download Now</div>
          </div>

          <div className="flex mt-12 laptop:mt-0">
            <img
              className="w-[70px] h-[70px] laptop:w-[110px] laptop:h-[110px]"
              src={require("../../../assets/icons/asgardEv_logo.png")}
            />
          </div>

          <div className="flex flex-col gap-2 mt-12 laptop:mt-0">
            <a
              href="https://onelink.to/9mmytd"
              target="_blank"
              referrerPolicy="no-referrer"
            >
              <img
                className="w-[110px] h-[35px] laptop:w-[150px] laptop:h-[50px] cursor-pointer"
                src={require("../../../assets/images/googlePlay.png")}
                alt="google-play"
              />
            </a>

            <a
              href="https://onelink.to/9mmytd"
              target="_blank"
              referrerPolicy="no-referrer"
            >
              <img
                className="w-[110px] h-[35px] laptop:w-[150px] laptop:h-[50px] cursor-pointer"
                src={require("../../../assets/images/appStore.png")}
                alt="appl-store"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
};

export default EventFooter;
